const getUrlSlug = (url, type) => {
	if (type === 'category') return url.match(/[^/]+$/)[0]
	if (type === 'tag') return url.match(/[^/]+$/)[0]
	if (type === 'post') return url.match(/([^/]+).html$/)[1]
	if (type === 'page') return url.match(/([^/]+).html$/)[1]
	return url
}

export default getUrlSlug
